module.exports = __webpack_public_path__ + "img/wiffleballbat.1a67420f.png";